import { Injectable, Injector } from '@angular/core';

import { ShuttlesService } from './shuttles.service';
import { BaseReportService } from './reportBase.service';
import type { IGetReportData } from '@shared/models';

@Injectable()
export class ReportShuttlesService extends BaseReportService implements IGetReportData {
    private shuttlesService: ShuttlesService;

    constructor(injector: Injector) {
        super(injector);
        this.shuttlesService = injector.get(ShuttlesService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];

        const shuttles = await this.shuttlesService.getAll();
        const sortedShuttles = shuttles.sort((a, b) => (a.shuttleName > b.shuttleName) ? 1 : -1);

        // Calculate data rows here.
        sortedShuttles.forEach((shuttle) => {
            const reportColValues: string[] = [
                shuttle.shuttleName, shuttle.status, shuttle.passengerCapacity.toString(),
                shuttle.color!, shuttle.description!];
            const rowInfo = this.buildRowInfo(reportColValues, 'data');
            allRows.push(rowInfo);
        });

        allRows.push(undefined);
        const reportData = { 'data': allRows };
        return reportData;
    }
}
